import { defineMessages } from 'react-intl';

type MessageDescriptor = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	signUp: MessageDescriptor;
	closeLabel: MessageDescriptor;
	existingUsers: MessageDescriptor;
	logInWithWorkEmail: MessageDescriptor;
	or: MessageDescriptor;
	joinWaitlist: MessageDescriptor;
	waitlistHelper: MessageDescriptor;
} = defineMessages({
	signUp: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.signUp.non-final',
		defaultMessage: 'Sign up',
		description:
			'Button in the top navigation bar of the Teamwork Graph microsite, shown to signed-out visitors immediately before the "Log in" button. It opens a dialog explaining how to get access to Teamwork Graph. "Teamwork Graph" is an Atlassian product or service name.',
	},
	closeLabel: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.closeLabel.non-final',
		defaultMessage: 'Close',
		description:
			'Accessible name for the icon-only button in the top corner of the sign-up dialog that closes the dialog. The button shows a cross icon and no visible text.',
	},
	existingUsers: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.existingUsers.non-final',
		defaultMessage: 'Using any of these products?{br}You already have the Teamwork Graph',
		description:
			'Two-line text in the sign-up dialog, directly below a row of product logos for Focus, Confluence, Rovo, Jira, Jira Service Management, Loom and Bitbucket. It tells visitors who already use one of those products that they already have Teamwork Graph. {br} is a line-break element inserted by the application between the question and the statement, not literal text. "Focus", "Confluence", "Rovo", "Jira", "Jira Service Management", "Loom", "Bitbucket" and "Teamwork Graph" are Atlassian product or service names.',
	},
	logInWithWorkEmail: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.logInWithWorkEmail.non-final',
		defaultMessage: 'Log in with work email',
		description:
			'Full-width button in the sign-up dialog, below the text for people who already use an Atlassian app. It starts the same Atlassian account log-in as the "Log in" button in the top navigation bar. "Work email" is the email address the visitor uses for their job.',
	},
	or: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.or.non-final',
		defaultMessage: 'Or',
		description:
			'Short word centred between two horizontal lines in the sign-up dialog. It separates the two alternatives: logging in with a work email above it, and joining the waitlist below it.',
	},
	joinWaitlist: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.joinWaitlist.non-final',
		defaultMessage: 'Join the waitlist',
		description:
			'Full-width link styled as a button in the sign-up dialog, for visitors who do not use an Atlassian app. It opens, in a new browser tab, the atlassian.com page where they can ask to be notified when Teamwork Graph can be used directly. "Teamwork Graph" is an Atlassian product or service name.',
	},
	waitlistHelper: {
		id: 'twg-microsite-experience.NavigationBar.SignupControl.waitlistHelper.non-final',
		defaultMessage: 'Get notified when access opens for everyone.',
		description:
			'Small helper text below the "Join the waitlist" link in the sign-up dialog. It tells visitors that if they join the waitlist, they will be notified when access to the product opens to everyone, not only to people who already use one of the products whose logos are shown above.',
	},
});
